<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_003
 * @created at      :   2026/02/10
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST003 from '@/views/popupSearch/PopupMST003/store';
import helpers from '@/utils/helpers';

var PopupMST003Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST003')) {
            store.registerModule('PopupMST003', PopupMST003);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST003', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST003', ['searchMst003Info']),
        ...mapMutations('PopupMST003', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                } else if (this.initData.CompanyCD !== undefined) {
                    this.data.company_cd = this.initData.CompanyCD;
                }
                if (this.initData.customer_cd !== undefined) {
                    this.data.customer_cd = this.initData.customer_cd;
                }
                if (this.initData.location_cd !== undefined) {
                    this.data.location_cd = this.initData.location_cd;
                }
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchMst003Info(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchMst003Info(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.person_id);
            this.$emit('onReferValueName', item.person_name);
            this.$emit('close');
        }
    }
};
export default PopupMST003Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
